import { TodoContext } from '../context/DataProvider';
import { ContactForm } from "../components/index";
import { useNavigate } from 'react-router-dom';
import { useState, useContext } from 'react';
import { AppBar,
        Avatar,
        Button,
        Box,
        Container,
        IconButton,
        Menu,
        MenuItem,
        Toolbar,
        Typography,
        Divider,
        Tooltip } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import MenuIcon from '@mui/icons-material/Menu';
import Images from '../static/ImagesProvider';

function ResponsiveAppBar({userAuth}) {
    const navigate = useNavigate();
    const {logOut, user, setUser} = useContext(TodoContext);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleDoNothing = () => {
        console.log('Click a nombre de usuario :>> ');
    };

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleLogIn = async () => {
        navigate('init');
    };

    const handleLogOut = async () => {
        await logOut();
        setUser(null);
    };

    const handleContact = () => {
        setDialogOpen(true);
    };

    const handleCloseContact = () => {
        setDialogOpen(false);
    };

    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: 'white'
            }}
        >
            <Container maxWidth="lg">
                <Toolbar disableGutters>
                    {/* Comportamiento maximizado */}
                    <Typography
                        noWrap
                        variant="h6"
                        component="a"
                        onClick={() => navigate('/')}
                        sx={{
                            width: '10%',
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'Barlow',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        <img src={Images.GluonKnowledgeLogo} width="100%" alt="gluon_logo"/>
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <Button
                            key='contacto_page'
                            onClick={() => handleContact()}
                            sx={{ my: 2, display: 'block' }}
                        >
                            Contáctanos
                        </Button>
                    </Box>

                    {/* Comportamiento minimizado */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            sx={{
                                color: "darkgray",
                                border: "2px solid lightgray",
                                borderRadius: '5px'
                            }}
                        >
                            <MenuIcon />
                        </IconButton>

                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            <MenuItem key='contacto_page' onClick={() => handleContact()}>
                                <Typography sx={{ textAlign: 'center' }}>Contáctanos</Typography>
                            </MenuItem>
                        </Menu>
                    </Box>

                    <Typography
                        component="a"
                        onClick={() => navigate('/')}
                        sx={{
                            mr: '22vh',
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1
                        }}
                    >
                        <img src={Images.GluonKnowledgeLogo} width="100%" alt="gluon_logo"/>
                    </Typography>

                    {/* Comportamiento general perfil */}
                    { user ?
                        <>
                            <Typography
                                noWrap
                                variant="h6"
                                sx={{
                                    mr: 2,
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: 'Barlow',
                                    color: 'lightslategray',
                                    textDecoration: 'none',
                                }}
                            >
                                { user?.displayName }
                            </Typography>

                            <Box sx={{ flexGrow: 0 }}>
                                <Tooltip title="Opciones">
                                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                        <Avatar alt={ user?.displayName } src={ user?.photoURL } />
                                    </IconButton>
                                </Tooltip>

                                <Menu
                                    keepMounted
                                    sx={{ mt: '45px' }}
                                    id="menu-appbar"
                                    anchorEl={anchorElUser}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorElUser)}
                                    onClose={handleCloseUserMenu}
                                >
                                    <MenuItem key='user_name' onClick={handleDoNothing} disabled sx={{ display: { xs: 'flex', md: 'none' } }}>
                                        <Typography sx={{ textAlign: 'center' }}>
                                            { user?.displayName }
                                        </Typography>
                                    </MenuItem>
                                    <Divider
                                        sx={{
                                            border: '1px solid lightslategray',
                                            width: '86%',
                                            marginLeft: '7%',
                                            display: { xs: 'flex', md: 'none' }
                                        }}
                                    />
                                    <MenuItem key='sales_view_page' onClick={() => navigate('/')}>
                                        <Typography sx={{ textAlign: 'center' }}>Vista pública</Typography>
                                    </MenuItem>
                                    <MenuItem key='administration_view_page' onClick={() => navigate('/adminView')}>
                                        <Typography sx={{ textAlign: 'center' }}>Vista de administración</Typography>
                                    </MenuItem>
                                    <MenuItem key='administration_list_page' onClick={() => navigate('/adminList')}>
                                        <Typography sx={{ textAlign: 'center' }}>Lista de administración</Typography>
                                    </MenuItem>
                                    <MenuItem key='logout_function' onClick={handleLogOut}>
                                        <Typography sx={{ textAlign: 'center' }}>Cerrar Sesión</Typography>
                                    </MenuItem>
                                </Menu>
                            </Box>
                        </>
                    :
                        <>
                            <IconButton key="login_function" color="primary" aria-label="Iniciar Sesión" onClick={handleLogIn}>
                                <Typography
                                    noWrap
                                    sx={{
                                        mr: 2,
                                        display: { xs: 'none', md: 'flex' },
                                        fontSize: '1.2rem',
                                        fontFamily: 'Barlow',
                                        color: 'lightslategray',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Ingresar
                                </Typography>
                                <LoginIcon />
                            </IconButton>
                        </>
                    }
                </Toolbar>
            </Container>

            <ContactForm open={dialogOpen} onClose={() => handleCloseContact() } />
        </AppBar>
    );
}

export default ResponsiveAppBar;
